export default "__VITE_ASSET__30cd151b__"